import {Injectable} from "@angular/core";

@Injectable()
export class SaleLineFiltersService {
  constructor() {}
}
